export * from './account.service';
import { AccountService } from './account.service';
export * from './citation.service';
import { CitationService } from './citation.service';
export * from './applePay.service';
import { ApplePayService } from './applePay.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './discount.service';
import { DiscountService } from './discount.service';
export * from './dropdown.service';
import { DropdownService } from './dropdown.service';
export * from './externalReports.service';
import { ExternalReportsService } from './externalReports.service';
export * from './location.service';
import { LocationService } from './location.service';
export * from './locationPaymentGatewaySetting.service';
import { LocationPaymentGatewaySettingService } from './locationPaymentGatewaySetting.service';
export * from './locationRate.service';
import { LocationRateService } from './locationRate.service';
export * from './locationSetting.service';
import { LocationSettingService } from './locationSetting.service';
export * from './receipt.service';
import { ReceiptService } from './receipt.service';
export * from './reportSchedule.service';
import { ReportScheduleService } from './reportSchedule.service';
export * from './role.service';
import { RoleService } from './role.service';
export * from './session.service';
import { SessionService } from './session.service';
export * from './storage.service';
import { StorageService } from './storage.service';
export * from './ticket.service';
import { TicketService } from './ticket.service';
export * from './tokenAuth.service';
import { TokenAuthService } from './tokenAuth.service';
export * from './transactionReport.service';
import { TransactionReportService } from './transactionReport.service';
export * from './user.service';
import { UserService } from './user.service';
export * from './whiteListCar.service';
import { WhiteListCarService } from './whiteListCar.service';
export const APIS = [AccountService, ApplePayService, CitationService, DashboardService, DiscountService, DropdownService, ExternalReportsService, LocationService, LocationPaymentGatewaySettingService, LocationRateService, LocationSettingService, ReceiptService, ReportScheduleService, RoleService, SessionService, StorageService, TicketService, TokenAuthService, TransactionReportService, UserService, WhiteListCarService];
